import React from 'react';
import { connect } from "react-redux";

class InitialFlowFooterQuestion extends React.Component {

  getFooterQuestion = () => {
    return (this.props.initialFlowStep === 1)
      ? `What room would you like to ${this.props.initialFlowType}?`
      : "Which layout best matches your kitchen?"
  };

  render() {
    return (
      <div className="flow-footer__question">
        {this.getFooterQuestion()}
      </div>
    )
  }
}

const mapStateToProps = (store) => {
  return {
    initialFlowStep: store.initialFlowState.initialFlowStep,
    initialFlowType: store.initialFlowState.initialFlowType,
  };
};

export default connect(mapStateToProps, {
})(InitialFlowFooterQuestion);
